import { createStore, applyMiddleware } from 'redux';
import logger from 'redux-logger'; // eslint-disable-line no-unused-vars
import immutableState from 'redux-immutable-state-invariant';
import { thunk } from 'redux-thunk';

import fetchMiddleware from '../components/Fetch/middleware';
import rootReducer from '../reducers';

// const createStoreWithMiddleware = applyMiddleware(thunk, logger, fetchMiddleware)(createStore);
const middlewares = [thunk, fetchMiddleware];

if (process.env.NODE_ENV === 'development') {
  middlewares.push(logger, immutableState());
}

const createStoreWithMiddleware = applyMiddleware(...middlewares)(createStore);
const store = createStoreWithMiddleware(
  rootReducer,
  (process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION__) && window.__REDUX_DEVTOOLS_EXTENSION__() // eslint-disable-line
);

export default store;
